import { LegalPageLayout } from '../components';

export function AcceptableUsePolicyPage() {
  return (
    <LegalPageLayout title="Acceptable Use Policy" lastUpdated="March 13, 2026">
      <p>
        This Acceptable Use Policy (&quot;AUP&quot;) governs your use of the Fias platform and
        services. This policy is incorporated into and forms part of our{' '}
        <a href="/legal/terms">Terms of Service</a>. Violation of this policy may result in
        suspension or termination of your account.
      </p>

      <h2>1. Prohibited Content</h2>
      <p>You may not use the Service to create, upload, share, or distribute content that:</p>
      <ul>
        <li>Is illegal or promotes illegal activities</li>
        <li>Contains or promotes child sexual abuse material (CSAM) or exploitation of minors</li>
        <li>Promotes violence, terrorism, or incites harm against individuals or groups</li>
        <li>Constitutes harassment, bullying, threats, or intimidation</li>
        <li>
          Contains hate speech targeting individuals or groups based on race, ethnicity, national
          origin, religion, gender, sexual orientation, disability, or other protected
          characteristics
        </li>
        <li>Is defamatory, fraudulent, or deliberately misleading</li>
        <li>
          Infringes on intellectual property rights, including copyrights, trademarks, or patents
        </li>
        <li>Contains malware, viruses, or other harmful code</li>
        <li>
          Violates the privacy of others, including sharing personal information without consent
        </li>
      </ul>

      <h2>2. Prohibited Conduct</h2>
      <p>You may not:</p>
      <ul>
        <li>Use the Service to spam, send unsolicited messages, or engage in phishing</li>
        <li>Attempt to gain unauthorized access to accounts, systems, or data</li>
        <li>Interfere with or disrupt the Service, servers, or networks</li>
        <li>Circumvent rate limits, security measures, or access controls</li>
        <li>
          Use automated tools (bots, scrapers, crawlers) to access the Service without authorization
        </li>
        <li>Impersonate any person or entity, or misrepresent your affiliation</li>
        <li>Use the Service for any purpose that violates applicable laws or regulations</li>
        <li>Sell, resell, or commercially exploit the Service without authorization</li>
        <li>Reverse-engineer, decompile, or disassemble any part of the Service</li>
      </ul>

      <h2>3. AI-Specific Restrictions</h2>
      <p>When using AI-powered features of the Service, you may not:</p>
      <ul>
        <li>
          Generate content intended to deceive others about its AI-generated nature where disclosure
          is required by law
        </li>
        <li>
          Use AI features to generate content that violates the prohibited content rules above
        </li>
        <li>Attempt to extract, reconstruct, or reverse-engineer the underlying AI models</li>
        <li>
          Use AI outputs as a substitute for professional advice (legal, medical, financial, or
          other regulated fields) without independent verification by a qualified professional
        </li>
        <li>
          Use AI features to generate bulk spam, misinformation, or synthetic media intended to
          mislead
        </li>
      </ul>

      <h2>4. Marketplace and Contributor Rules</h2>
      <p>Contributors who publish Arches to the marketplace must:</p>
      <ul>
        <li>Accurately describe their Arche&apos;s functionality and capabilities</li>
        <li>
          Not include hidden functionality, data collection, or behavior not disclosed in the
          Arche&apos;s description
        </li>
        <li>Not publish Arches that impersonate or infringe on other contributors&apos; work</li>
        <li>
          Comply with all applicable laws and the terms of any third-party services their Arches
          integrate with
        </li>
      </ul>

      <h2>5. Reporting Violations</h2>
      <p>
        If you encounter content or behavior that violates this policy, please report it using the
        in-app reporting tools or by contacting us at{' '}
        <a href="mailto:abuse@fias.io">abuse@fias.io</a>.
      </p>
      <p>We review all reports and take them seriously.</p>

      <h2>6. Enforcement</h2>
      <p>
        We enforce this policy at our discretion. Depending on the severity and nature of the
        violation, we may take one or more of the following actions:
      </p>
      <ul>
        <li>
          <strong>Warning:</strong> A notification that your content or behavior violates this
          policy, with a request to correct it
        </li>
        <li>
          <strong>Content removal:</strong> Removal of specific content that violates this policy
        </li>
        <li>
          <strong>Temporary suspension:</strong> Temporary restriction of your access to the Service
        </li>
        <li>
          <strong>Permanent termination:</strong> Permanent removal of your account and access to
          the Service
        </li>
      </ul>
      <p>
        Severe violations (such as CSAM, terrorism, or imminent threats of violence) may result in
        immediate termination without prior warning and may be reported to law enforcement.
      </p>

      <h2>7. Appeals</h2>
      <p>
        If you believe an enforcement action was taken in error, you may appeal by contacting us at{' '}
        <a href="mailto:appeals@fias.io">appeals@fias.io</a> within 14 days of the action. Please
        include your username and a description of why you believe the action was incorrect. We will
        review your appeal and respond within 30 days.
      </p>

      <h2>8. Changes to This Policy</h2>
      <p>
        We may update this policy from time to time. Material changes will be posted on the Service
        with a new &quot;Last Updated&quot; date. Your continued use of the Service constitutes
        acceptance of the updated policy.
      </p>

      <h2>9. Contact</h2>
      <p>If you have questions about this policy, please contact us at:</p>
      <p>
        Fias Inc.
        <br />
        Email: <a href="mailto:legal@fias.io">legal@fias.io</a>
      </p>
    </LegalPageLayout>
  );
}
